import React, {useEffect, useState, useContext} from 'react';
import MachinesImages from '../../../components/Machine/MachinesImages';
import { NavigationContext } from '../../../context/navigation-context';
import { useParams, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import PaxVideoUploader from '../PaxVideoUploader/PaxVideoUploader';




const Personalise = () => {

    const { setHeaderData } = useContext(NavigationContext),
    history = useHistory(),
    params = useParams()
    const changeType = (typeId) => {
        setType(typeId)
        switch(typeId) {
            case 0: 
                history.replace("/personalise/machine")
                break;
            case 1: 
                history.replace('/personalise/user')
                break;
            case 2: 
                history.replace('/personalise/pax')
                break;
        }
    }
    const getType = () => {
        if (params.type) {
            switch(params.type) {
                case "machine": 
                    return 0;
                case "user": 
                    return 1;
                case "pax": 
                    return 2;
            }
        } else return 2
    } 
    const [type, setType] = useState(getType())
    useEffect(() => {
        changeType(type)
        setHeaderData({text: "Personalizacja"})
    }, [])
    return (
        <>
            <div>
                <ul className="nav nav-tabs machine-tabs mb-3">
                <li className="nav-item">
                            <button
                                className={`nav-link btn ${type === 2 && 'active'}`}
                                onClick={() => type !== 2 && changeType(2)}
                                tabIndex="2"
                            >
                                Ustawienia PAXa
                            </button>
                        </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link btn ${type === 0 && 'active'}`}
                            onClick={() => type !== 0 && changeType(0)}
                            tabIndex="0"
                        >
                            Ustawienia R24 VMC
                        </button>
                    </li>
                </ul>
            </div>
            {
                type === 0 && <MachinesImages /> ||
                type === 2 && <PaxVideoUploader />
            }
            
            
        </>
    )

}
export default Personalise;